import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the visitor asked the OS for reduced motion, read once, now.
 * False where matchMedia doesn't exist (server render, jsdom).
 */
export function prefersReducedMotion() {
	return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(QUERY).matches;
}

/**
 * The reduced-motion preference as React state, updated if the visitor
 * changes the setting while the page is open.
 */
export function usePrefersReducedMotion() {
	const [reduced, setReduced] = useState(prefersReducedMotion);

	useEffect(() => {
		if (typeof window === "undefined" || !window.matchMedia) return undefined;
		const query = window.matchMedia(QUERY);
		if (!query.addEventListener) return undefined;
		const onChange = (event) => setReduced(event.matches);
		query.addEventListener("change", onChange);
		return () => query.removeEventListener("change", onChange);
	}, []);

	return reduced;
}
